export const TOOL_NAME = "Korea Value-up Screener";
export const TOOL_DESCRIPTION =
  "Track South Korean companies' Value-up programs with Smartkarma's Impact Score.";
